module.exports = __webpack_public_path__ + "static/MapStaticImage-1eb7eb845dcf0b0bd98352638e48d612.jpeg";